import React from "react";
import JsonFormatter from "react-json-formatter";

export default function TtDebug(props) {
  const { x } = props;
  //console.log(x);

  return (
    <div
      className="tt-debug"
      style={{
        display: "flex",
        flexDirection: "columns",
        marginBottom: 100,
        // display: "none",
      }}
    >
      {x.map((d, k) => (
        <div
          key={k}
          style={{
            // flex: 0.33,
            padding: 5,
            maxHeight: 500,
            overflowY: "auto",
            maxWidth: "33%",
            minWidth: "33%",
          }}
        >
          <small>
            <strong>{d.title}:</strong>
          </small>
          <JsonFormatter
            json={JSON.stringify(d.data)}
            tabWith={4}
            jsonStyle={{
              style: {
                color: "#fff",

                backgroundColor: "DarkSlateGrey",
                padding: "25px",
              },
              propertyStyle: { color: "#fff", fontWeight: "400" },
              stringStyle: { color: "DarkKhaki" },
              numberStyle: { color: "Coral" },
              booleanStyle: { color: "Coral" },
            }}
          />
        </div>
      ))}
    </div>
  );
}
